module.exports = __webpack_public_path__ + "img/接入指南密钥生成.03592023.png";